import { render, staticRenderFns } from "./TabList.vue?vue&type=template&id=2c0194ac"
import script from "./TabList.vue?vue&type=script&lang=ts"
export * from "./TabList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports